import React from 'react';
import SuccessCard from './SuccessCard';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

interface SuccessesSectionProps {
  successes: Array<{
    Area: string;
    Success: string;
    ContinuedDevelopment: string;
  }>;
}

const SuccessesSection: React.FC<SuccessesSectionProps> = ({ successes }) => {
  if (!successes || successes.length === 0) {
    return null;
  }

  return (
    <div style={{
      background: '#fff',
      borderRadius: '12px',
      padding: '2rem',
      //marginBottom: '1.5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      borderLeft: '4px solid #38a169',
      breakInside: 'avoid'
    }}>
      <h2 style={{ 
        color: '#38a169', 
        fontSize: '1.5rem', 
        fontWeight: '600',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center'
      }}>
        <CheckCircleOutlinedIcon style={{ marginRight: '8px' }} />
        Successes
      </h2>
      {successes.map((success, index: number) => (
        <SuccessCard 
          key={index} 
          success={success} 
          index={index} 
        />
      ))}
    </div>
  );
};

export default SuccessesSection;
